import ContractView from "layouts/contract-view";
import { getClientAccessToken, getClientSession } from "utils/clientSession";
import { Navigate } from "react-router-dom";

export default function ClientContractView() {
  const session = getClientSession();
  const accessToken = getClientAccessToken();

  if (!session || !accessToken) {
    return <Navigate to="/login" replace />;
  }

  return (
    <ContractView
      portalVariant="client"
      expectedCustomerId={session.customerId}
      clientAccessToken={accessToken}
    />
  );
}
